import React, { useEffect } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";

import Navbar from "./components/Navbar";
import Home from "./components/Home";
import Services from "./components/Services";
import ServiceLanding from "./components/ServiceLanding";
import AboutUs from "./components/AboutUs";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import Seo from "./components/Seo";
import StickyCta from "./components/StickyCta";
import { pageTransition } from "./components/motion";

import "./styles.css";

function App() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "auto",
    });
  }, [location.pathname]);

  return (
    <>
      <Seo pathname={location.pathname} />
      <Navbar />

      <AnimatePresence mode="wait">
        <motion.main
          key={location.pathname}
          className="page-transition"
          variants={pageTransition}
          initial="initial"
          animate="animate"
          exit="exit"
        >
          <Routes location={location}>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/:serviceSlug" element={<ServiceLanding />} />
            <Route path="/seo-services-hyderabad" element={<ServiceLanding />} />
            <Route path="/google-ads-services" element={<ServiceLanding />} />
            <Route path="/website-development-company" element={<ServiceLanding />} />
            <Route path="/ai-automation-services" element={<ServiceLanding />} />
            <Route path="/social-media-marketing" element={<ServiceLanding />} />
            <Route path="/digital-marketing-agency-hyderabad" element={<ServiceLanding />} />
            <Route path="/seo-company-vijayawada" element={<ServiceLanding />} />
            <Route path="/about" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </motion.main>
      </AnimatePresence>

      <Footer />
      <StickyCta />
    </>
  );
}

export default App;
